module.exports = __webpack_public_path__ + "static/img/empty.6459867.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-date-picker3/src/images/empty.png
// module id = 17GW
// module chunks = 4